import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/late';

function lateCreate(state, action) {
  state.data = action.payload.data;
  state.result = action.payload.result;
  state.nota = action.payload.nota;
  state.conexion = false;
  state.error = false;
}

function lateConexion(state, action) {
  state.conexion = action.payload.conexion;
}

function lateError(state, action) {
  state.error = action.payload.error;
}

const lateReducer = createSlice({
  name: 'late',
  initialState: initState,
  reducers: {
    lateCreate,
    lateConexion,
    lateError,
  },
});

export const lateActions = {
  ...lateReducer.actions,
};

export default lateReducer.reducer;
